import React, { useContext } from 'react';
import TranslationsContext from '../TranslationsContext';

const SectionTitles = ({ step, titleObject, logoUrl }) => {
	const t = useContext(TranslationsContext);

	return (
		<div
			className="subscription-configurator__titles column small-12"
			onClick={(e) => {
				const details = [...document.querySelectorAll('details')];
				if (!details.some((f) => f.contains(e.target instanceof Node ? e.target : null))) {
					details.forEach((f) => f.removeAttribute('open'));
				} else {
					details.forEach((f) => (!f.contains(e.target instanceof Node ? e.target : null) ? f.removeAttribute('open') : ''));
				}
			}}
		>
			<h1
				className={`${titleObject.title_size} text-center ${titleObject.gradient_title == true ? 'gradient-text' : ''}`}
				style={{ color: titleObject.gradient_title == true ? `${titleObject.color_title}` : 'inherit' }}
			>
				{step == 1 && t('welcome_to')}
				{titleObject.title}
			</h1>

			<div className="titles__logo-wrapper flex-container flex-dir-row align-center-middle">
				<img loading="lazy" height="197" width="200" src={logoUrl} alt="Logo" />
			</div>

			{step == 1 && (
				<h2 className={`${titleObject.subtitle_size} text-center titles__subtitle`} style={{ color: `${titleObject.color_subtitle}` }}>
					{titleObject.subtitle}
				</h2>
			)}

			{step == 4 && (
				<h2 className={`${titleObject.subtitle_size} text-center titles__subtitle`} style={{ color: `${titleObject.color_subtitle}` }}>
					{t('subscription_overview')}
				</h2>
			)}

			{step == 5 && (
				<h2 className={`${titleObject.subtitle_size} text-center titles__subtitle`} style={{ color: `${titleObject.color_subtitle}` }}>
					{t('thank_you_fab4')}
				</h2>
			)}
		</div>
	);
};

export default SectionTitles;
